import { textSizeOptions, useTextSize } from '../../context/text-size';
import * as S from './style';

/**
 * Renders nothing outside TextSizeProvider, which scopes the control to the routes
 * that opted in without threading props through Layout/Header.
 */
const TextSizeControl = () => {
  const textSize = useTextSize();

  if (!textSize) return null;

  const { scale, saveScale } = textSize;

  return (
    <S.Group role="group" aria-label="Text size">
      {textSizeOptions.map(({ label, scale: optionScale, description }) => (
        <S.SizeButton
          key={label}
          type="button"
          aria-label={description}
          aria-pressed={scale === optionScale}
          isSelected={scale === optionScale}
          onClick={() => saveScale(optionScale)}
        >
          {label}
        </S.SizeButton>
      ))}
    </S.Group>
  );
};

export default TextSizeControl;
